import React from 'react';
import {FormControlLabel, Stack, Switch, TextField} from '@mui/material';

/**
 * Pure controlled form for {@link MachineBasicUpdateDto}: name + disabled.
 *
 * No save logic, no API calls — caller owns the value via {@code value} +
 * {@code onChange}. Wrap in <EditableCard> for Pattern B (inline-card edit)
 * or mount directly inside a page-level <form> for Pattern A (whole-machine
 * save). Behaviour is identical in both cases.
 *
 * Shape: {@code { name: string, disabled: boolean }}.
 */
const MachineBasicForm = ({value, onChange}) => {
    const set = (patch) => onChange({...value, ...patch});
    return (
        <Stack spacing={2}>
            <TextField
                label="Name"
                value={value.name ?? ''}
                onChange={(e) => set({name: e.target.value})}
                required
                fullWidth
                size="small"
            />
            <FormControlLabel
                control={
                    <Switch
                        checked={!!value.disabled}
                        onChange={(e) => set({disabled: e.target.checked})}
                    />
                }
                label="Disabled"
            />
        </Stack>
    );
};

export default MachineBasicForm;
